import TerminalList from '../components/lists/TerminalList';
import {
  useCarriers,
  useCarrierTerminalMap,
} from '../hooks/apiHooks';
import { useTerminals } from '../hooks/apiHooks/terminal';
import Layout from '../layout';

const AdminTerminalsPage = ({ routes }) => {
  const { allCarriers } = useCarriers();
  const { allTerminals } = useTerminals();
  const { carrierTerminalMap } = useCarrierTerminalMap();

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      <TerminalList
        carriers={allCarriers}
        carrierTerminalMap={carrierTerminalMap}
        id="terminals"
        terminals={allTerminals}
      />
    </Layout>
  );
};

export default AdminTerminalsPage;
